<template> 
    <div class="container" id="catlist">
        <div class="card p-4">
            <div class="container-fluid vendorDetailsWrapper mb-3">
                    <div class="row align-items-center">
                        <div class="col-md">
                            <div class="row align-items-center">
                                <!-- <div class="col-auto" v-if="showroomId && !showroomId.custom_addon">
                                    <div>
                                        <img :src="set_image(business_logo)" class="img-fluid vendorLogo" alt=""/>
                                    </div>
                                </div> -->
                                <div class="col-auto">
                                    <div>
                                        <h3 class="font-18 mb-1">{{ showroom_name }}</h3>
                                        <div class="d-flex flex-wrap textGreen">
                                            <div class="starsWrapper pe-3 font-16">
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                                <i aria-hidden="true" class="fa fa-star"></i>
                                            </div>
                                            <div class="fw-medium">5.0</div>
                                        </div>
                                        <div class="d-flex font-16">
                                            <a :href="'tel:'+phone_no" class="phoneLink">
                                                <span class="me-2"><i aria-hidden="true" class="fa fa-phone"></i></span>
                                                <span class="fw-medium">{{ phone_no|phone }}</span>
                                            </a>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>

                        <div class="col-md">
                            <ul class="list-unstyled ps-0 d-flex flex-wrap mb-0 justify-content-md-end mt-3 mt-md-0">
                                <li>
                                    <button class="actionBtn mb-2 mb-md-0" @click="$root.$emit('toogle_showroom', isVisible)">About Us</button>
                                </li>
                                <li v-if="web_site">
                                    <button class="actionBtn mb-2 mb-md-0" @click="redirect_site(web_site)">Homepage</button>
                                </li>
                                <!-- <li>
                                    <button @click="$router.push('/register')" class="actionBtn me-0">Sign up for FREE</button>
                                </li> -->
                            </ul>
                        </div>
                    </div>
                </div>
            
            <div class="card-top container-fluid">
                
                <div class="row mb-3 align-items-center">
                    <div class="col-md-6">
                        <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);"
                    aria-label="breadcrumb">
                            <ol class="breadcrumb mb-0 ccc ps-0" >
                                <li class="breadcrumb-item">
                                
                                <a href="javascript:void(0);" @click="push_state(BASE_URL,'HM' )">All Products</a>

                                </li>
                                <li class="breadcrumb-item" aria-current="page" v-for="(item, x) in breadcumArr"
                                :key="'br' + x" :class="{active:breadcumArr.length==(x+1)}">
                                <span v-if="breadcumArr.length==(x+1)">{{ item.name }}</span> 
                                <a href="javascript:void(0);" @click="push_state(BASE_URL+'category/'+item.slug_url,item.slug_url,shop_id)" v-else>{{ item.name }}</a>
                                
                                </li> 
                            
                            </ol>

                        </nav>
                    </div>

                    <div class="col-md-6">
                         
                    </div> 
                </div>
                <h3 class="mb-3" v-if="category.parent && category.parent!='all'">{{ category.parent }}</h3>
            </div>


            <div class="row g-4">
                <div v-for="(category, index) in listcategory" :key="'bl' + index" class="col-md-4">
                    <!-- Flexbox card to ensure equal height and button alignment -->
                    <div class="card h-100 mb-4 d-flex flex-column">
                    <!-- Card Image with light gray background and set height -->
                    <div
                        class="card-img-top d-flex justify-content-center align-items-center"
                        :style="{ backgroundColor: '#f0f0f0', height: '250px' }"
                    >
                        <img :src="set_image(category.photo)" alt="Category Image" class="img-fluid" style="max-height: 150px;">
                    </div>

                    <!-- Card Body with flex-grow to push the button down -->
                    <div class="card-body d-flex flex-column flex-grow-1">
                        <div class="flex-grow-1">
                        <h5 class="card-title">{{ category.name }}</h5>
                        <ul class="list-unstyled">
                            <li v-for="(child, i) in getChildren(category.id)" :key="i"> 

                            <a href="javascript:void(0);" @click="push_state(BASE_URL+'category/'+child.slug_url,child.slug_url)" class="text-decoration-none">{{ child.name }}</a>
                            </li>
                        </ul>
                        </div>
                        <!-- Shop All Button aligned at the bottom -->
                        <router-link :to="'/category/' + category.slug_url + '/product'" class="btn btn-link mt-auto p-0">
                        Shop All {{ category.name }} >
                        </router-link>
                    </div>
                    </div>
                </div>
                </div>





 
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios"; 
import Loading from "../../components/Loading.vue";

 

/* const TopProduct = () => ({
    component: import("../TopProduct.vue"),
    loading: Loading,
    timeout: 3000,
}); */

export default {
    props: ["categories","isVisible","showroom_name","business_logo","phone_no","web_site"],
    metaInfo() {
    return {
        title: this.meta.page_title +' | ' + appname,
        meta: [
        {
            vmid: 'description',
            name: 'description',
            content: this.meta.description
        },
        {
            vmid: 'canonical',
            rel: 'canonical',
            href: this.meta.currentUrl
        },
        {
            vmid: 'og:title',
            property: 'og:title',
            content: this.meta.page_title +' | ' + appname
        },
        {
            vmid: 'og:description',
            property: 'og:description',
            content: this.meta.description
        },
        {
            vmid: 'twitter:title',
            property: 'twitter:title',
            content: this.meta.page_title +' | ' + appname
        },
        {
            vmid: 'twitter:description',
            property: 'twitter:description',
            content: this.meta.description
        },
        {
            vmid: 'twitter:image',
            property: 'twitter:image',
            content: this.meta.image
        },
        {
            vmid: 'keywords',
            property: 'keywords',
            content: this.meta.keywords
        },
        ]
    };
    },

    components: { 
      //  TopProduct,
    },
    data() {
        return {
            meta:{
                page_title:'Home',
                description:'Home ' + appname,
                keywords:'Home ' + appname,
                currentUrl: window.location.origin + this.$route.fullPath,
                image:''
            },
            BASE_URL:process.env.BASE_URL,            
            parent_cat:'',
            categoryList: [],
            subCategory: [],
            heading: "Appliances",            
            profile: [],
            selectedCategory: "",
            showroom: "",
            listcategory: "",
            breadcumArr: '',
            finalArrayOfObjects: [],
            shop_id:shop_id,
        };
    },
    watch: { 
        async categories(n) {
            //this.listcategory = n;
        }, 
        '$route.params.category': {
            handler: function (slug) {
                this.get_childs()
                this.gen_breadcum();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        ...mapGetters({
            // 'showroom':'Common/ShowRoom',
            showroomId: "Common/MyItem",
            category: "Common/Category",
            ProductCategory: "Common/ProductCategory",
            TopProduct: "Common/TopProduct",
            ParentCategory: "Common/ParentCategory",
            SubCategory: "Common/SubCategory",
        }),
    },
    methods: {
        ...mapActions("Common", [
            "updateNewLayout",
            "updateSubCategory",
            "updateBreadcrumb",
            "updateCategory",
            "updateProductCategory",
            "setTopProduct",
            "setPagination",
            "setParentCategory",
            "setSubCategory",
        ]),

        async get_childs(cat='') {
            if(this.showroom){
              cat = cat?cat: this.$route.params.category
              cat = (cat === undefined || cat === 'HM' ? '' :cat)
            if (cat) {
                let obj = this.showroom.category.find(o => o.slug_url === cat)
                this.parent_cat=obj
                this.listcategory = this.showroom.category.filter(item => item.parent_id === obj.id);
                this.updateProductCategory({
                    category_id:obj.id,
                    category_name:obj.name,
                })
            } else {
                this.parent_cat=''
                this.listcategory = this.showroom.category.filter(item => item.parent_id === null);
            }
            if (this.listcategory.length==0) {
                this.$router.push( '/category/' + cat+'/product').catch(() => {})
            }
        }
        },

        getChildren(parentId) {
        return this.showroom.category.filter(category => category.parent_id === parentId);
        },

        gen_breadcum(cat='') {
              cat = cat?cat: this.$route.params.category
            let res =[];
            cat = (cat === undefined || cat === 'HM' ? '' :cat)
            console.log(cat);
            if(cat){
            if (this.showroom && this.showroom.category && this.showroom.category.length > 0) {
                let result = this.showroom.category.filter((word) => word.slug_url === cat);
                res = [];
                let ids = result[0].parent_ids.split(',');

                for (const i of ids) {
                    let b = this.showroom.category.filter((word) => word.id == i);
                    res.push(b[0])
                }
            }
        }else{
            res =[]
        }

            this.breadcumArr = res
            let lastArrayElement = res[res.length - 1];
            if(lastArrayElement){
            this.meta.page_title = lastArrayElement.name || 'Home';
            this.meta.currentUrl = window.location.href
            this.meta.description = lastArrayElement.name || 'Home';
            this.meta.keywords = lastArrayElement.name || 'Home';
            this.meta.image = this.set_image(lastArrayElement.photo)|| '';
            }
        },
        push_state(params,category,vsd_id){
            history.pushState({category: category,vsd_id:vsd_id}, "", params);           
            this.get_childs(category)
            this.gen_breadcum(category);
        }
    },

    created() {
        //this.contentScroll('catlist');
        this.setPagination({
            paginationLink: "",
            nextUrl: "",
            prevUrl: "",
            total: "",
            current_page: "",
            prePage: "",
        });

        let loader = "";
        loader = this.$loading.show({
            container: this.$refs.search_tab,
        });
        axios
            .get("/api/visualization/shop_profile", {
                params: {
                    showroom: this.showroomId.showroom,
                    vsd_id:shop_id,
                    all_cat: 1
                },
            })
            .then((res) => {
                loader.hide();
                this.showroom = res.data.data;
                this.get_childs()
                this.gen_breadcum() 
                let categoryList =
                    this.category.list.length > 0
                        ? this.category.list
                        : res.data.data.category; 

            })
            .catch((error) => {
                //console.log(error)
                loader.hide();
            });

        this.updateNewLayout("Yes");

        loader.hide();
    },
};

</script>
<style scoped>
.breadcrumb{
    background-color: transparent !important;
}
.breadcrumb-item a
{
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
}
.card-img-top img {
  width: auto;
  max-width: 100%;
  height: auto;
}
.main-content .card{
    background: rgba(255, 255, 255, 1);
}





</style>